import {EmployeeRoleEnum} from "../../enums/employee-role.enum";

export class AddOrEditEmployeeModel {
  public id: string;
  public firstName: string;
  public lastName: string;
  public email: string;
  public phone: string;
  public address: string;
  public venueEmployeeTypeId: EmployeeRoleEnum;
  public pin: string;
  public pictureUrl: string;
  public languageId: number;
}
